import { type FC } from 'react';
import { defineMessages, useIntl } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import InfoCircle from 'dibs-icons/exports/InfoCircle';

import { useQuickView } from 'dibs-search-product-tile/exports/QuickViewProvider';
import { trackEvent } from 'dibs-tracking';

import classnames from 'classnames';
import dibsCss from 'dibs-css';
import styles from './styles.scss';

const messages = defineMessages({
    label: {
        id: 'dibs-buyer-product-tile.QuickViewButton.label',
        defaultMessage: 'Show quick view information',
    },
});

type QuickViewButtonProps = {
    index: number;
};

export const QuickViewButton: FC<QuickViewButtonProps> = ({ index }) => {
    const { formatMessage } = useIntl();
    const { openQuickView } = useQuickView();

    return (
        <Link
            dataTn="quick-view-button"
            ariaLabel={formatMessage(messages.label)}
            onClick={() => {
                openQuickView?.(index);
                trackEvent({
                    category: 'product',
                    action: 'item tile info icon click',
                });
            }}
            className={classnames(styles.quickViewButton, dibsCss.hFit, dibsCss.fillStorm)}
        >
            <InfoCircle variation="14" />
        </Link>
    );
};
